<template>
  <content class="integral-content">
    <el-table
      v-loading="loading"
      :data="tableData"
      stripe
      style="width: 100%;margin-top:20px"
    >
      <el-table-column prop="alliance_room" label="联盟商家"></el-table-column>
      <!-- <el-table-column
        prop="alliance_room"
        label="本站使用联积分"
      ></el-table-column> -->
      <el-table-column prop="point" label="使用积分"></el-table-column>
      <el-table-column prop="used_point" label="消耗积分"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">{{
          scope.row.status | now_status
        }}</template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="choseAudit(scope.row.alliance_app_id)"
            style="color:#e27470"
            >审核联盟</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="bot-pagination"
      background
      layout="prev, pager, next"
      :page-count="total"
    ></el-pagination>
    <!-- 添加聯盟油站 -->
    <el-dialog
      title="请审核"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div>
        <el-radio-group
          size="small"
          style="margin-top: 20px"
          v-model="sendForm.status"
        >
          <el-radio-button
            v-for="(item, index) in shopOption"
            :label="item.value"
            :key="index"
          >
            {{ item.name }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="audit_liance">确 定</el-button>
      </span>
    </el-dialog>
  </content>
</template>
<script>
import { Button, Slider } from "element-ui";
import {
  getIntegralList,
  auditAlliance,
  addAlliance,
  getAppMsg,
  getLianceList
} from "@/api/merchant";
import { mapGetters } from "vuex";
export default {
  components: {
    Button,
    Slider
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  filters: {
    now_status: function(val) {
      switch (val) {
        case 0:
          return "邀请中";
        case 1:
          return "联盟成立";
        case 2:
          return "联盟拒绝";
        case 3:
          return "联盟结束";
        case -1:
          return "待审核邀请";
        default:
          break;
      }
    }
  },
  data() {
    return {
      visible: false,
      // 0邀请中 1联盟成立 2联盟拒绝 3联盟结束
      top_nav: [
        {
          id: 0,
          name: "油站",
          num: ""
        },
        {
          id: 1,
          name: "本站消耗他站积分",
          num: ""
        },
        {
          id: 2,
          name: "他站消耗本站积分",
          num: ""
        }
      ],
      dialogVisible: false,
      tableData: [],
      total: 0,
      loading: true,
      value: 1,
      oil_str: "",
      selectArr: [],
      sideItem: [
        {
          id: 1,
          name: "联盟列表",
          url: "market/marketing/client/integral/integral-list"
        },
        {
          id: 2,
          name: "积分订单",
          url: "market/marketing/client/integral/point-order"
        }
      ],
      options: [
        {
          value: 0,
          label: "邀请中"
        },
        {
          value: 1,
          label: "联盟成立"
        },
        {
          value: 2,
          label: "联盟拒绝"
        },
        {
          value: 3,
          label: "联盟结束"
        },
        {
          value: -1,
          label: "待审核邀请"
        }
      ],
      shopOption: [
        {
          name: "审核通过",
          value: "1"
        },
        {
          name: "审核拒绝",
          value: "2"
        }
      ],
      sendForm: {
        alliance_app_id: "",
        status: ""
      },
      name: "" //搜索
    };
  },
  created() {
    this.getPointList();
  },
  methods: {
    choseAudit(alliance_app_id) {
      this.sendForm.alliance_app_id = alliance_app_id;
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          // done();
          this.sendForm = {
            alliance_app_id: "",
            status: ""
          };
          this.dialogVisible = false;
        })
        .catch(_ => {});
    },
    changeLabel(arr) {
      this.getPointList(arr.toString());
    },
    async open_liance(app_id) {
      try {
        const data = {
          token: this.token,
          app_id: this.app_id,
          alliance_app_id: app_id
        };
        const res = await addAlliance(data);
        this.$message.success(res.msg);
        this.getPointList();
      } catch (error) {
        console.log(error);
      }
    },
    // 解除关系
    async audit_liance() {
      this.$confirm("请再次确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.sendForm.status == "") {
          this.$message.warning("请先选择");
          return false;
        }
        const data = {
          token: this.token,
          app_id: this.app_id,
          alliance_app_id: this.sendForm.alliance_app_id,
          status: this.sendForm.status
        };
        this.dialogVisible = false;
        auditAlliance(data).then(res => {
          this.$message(res.msg);
          this.getPointList();
        });
      });
    },
    async getPointList(status = "-1") {
      try {
        this.loading = true;
        const data = { token: this.token, app_id: this.app_id, status };
        const res = await getIntegralList(data);
        if (res.code === 200) {
          if (res.data.data.length > 0) {
            const { num, use_total, be_used_total } = res.data;
            // console.log("数据", num, use_total, be_used_total);
            this.top_nav.forEach((item, index) => {
              switch (index) {
                case 0:
                  item.num = num;
                  break;
                case 1:
                  item.num = use_total;
                  break;
                case 2:
                  item.num = be_used_total;
                  break;
              }
            });
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.tableData = [];
            this.$message.error("暂无数据...");
            this.loading = false;
          }
        } else {
          throw res;
        }
      } catch (error) {
        this.tableData = [];
        this.$message.error(res.msg);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.integral-content {
  width: 100%;
  padding: 0 10px;
}

.add-oil {
  width: 100%;
  margin: 20px 0;
}
.bot-pagination {
  float: right;
  margin-top: 20px;
}
.xz-options {
  width: 300px;
  margin-left: 20px;
}
</style>
